import { Box } from "@chakra-ui/react";
import { ColorIcon, Spacing } from "goi_common";
import { BaseButton, BaseStack, baseColors } from "goi_common/src/design-system";

/**
 * E5 「임종하셨다면 지금 바로 전화하기」(흰 버튼). 하단 고정 영역에서 주 버튼 아래에 둔다.
 * #358 임종 배너가 늘 보이는 자리에 있어 전화가 늘었던 만큼, 질문 화면마다 계속 띄운다(2026-11-03 주완).
 */
export default function UrgentCallButton({ onClick }: { onClick: () => void }) {
  return (
    <BaseButton type="assistive_1" outlined size="large" onClick={onClick}>
      <BaseStack direction="horizontal" alignItems="center">
        <ColorIcon name="icon_normal_call_fill" size={20} color={baseColors.label_normal} />
        <Spacing gap={6} orientation="horizontal" />
        <Box className="body_1_normal_m" color={baseColors.label_normal}>
          임종하셨다면 지금 바로 전화하기
        </Box>
      </BaseStack>
    </BaseButton>
  );
}
